import {createAsyncThunk, createSlice} from '@reduxjs/toolkit'
import {http} from 'hiya-common/src/utils/axios'
import toast from 'react-hot-toast'

export enum PageTypeEnum {
  rules = 1,
  schedule,
  family,
}
export const areaList = [0, 1]
export const areaChinese = {
  '0': '中东',
  '1': '印尼',
}
export enum RaceEnum {
  regular = 1,
  glory,
}
interface RoomInfoItem {
  room_id: number
  avatar: string
  name: string
  score: number
}
interface MemberProps {
  avatar: string
  id: number
  name: string
  zy_id: string
}
export interface ListItemType {
  member_info: MemberProps
  group_name?: string
  rank?: string
  score: number
  meter?: number
  room_list?: Array<RoomInfoItem>
}

// 道具列表
interface PropItemType {
  pid: number
  name: string
  num: number
  image: string
  type: 1 | 2
  meters: number
}
interface ResFamilyItem {
  // 为0表示该家族已经被淘汰 为1表示该家族晋级
  family_status: 0 | 1
  name: string
  rank: number
}
export interface FamilySpeedSt {
  // 第几个赛季，后续可能有下一轮活动
  sid: number
  // 0:常规赛 1：巅峰赛
  race_type: 0 | 1
  race_day_list: Array<string>
  race_day: number
  // 比赛状态为0表示该日比赛已结束，为1表示比赛进行中，2:未开始
  race_status: 0 | 1 | 2
  // 轮次list
  circle_list: Array<string>
  // 第几轮
  circle_index: number
  // [A,B,C,D] 分组的数组
  group_list: Array<string>
  // 第几组 从1开始
  group_index: number
  // 奖金比例
  prize_rate: string
  // 常规赛奖金比例
  prize_rate_regular: string
  // 巅峰赛奖金比例
  prize_rate_peak: string
  // 奖金数目
  prize_pool: number
  // 赛程接口
  // 不同的天的奖池奖金数目 当日奖金数目
  schedule_prize_pool: number
  // 1: 返回的是获奖家族列表
  prize_status: number
  // 1：处于比赛休息中
  rest_status: number
  accounting_status: number
  // 赛程接口家族是否晋级
  schedule_family_status: 0 | 1
  //   是否展示用户所在家族排名信息
  // 1：展示
  show_own: number
  own: ListItemType
  family_race_list: ListItemType[]
  // 赛程的race status
  raceSchedule_race_status: 0 | 1 | 2
  // 这轮开始时间
  st_str: string
  // 这轮结束时间
  et_str: string
  // m进n的字符串
  m_to_n_str: string
  // 比赛后剩多少个
  m_to_n: string
  // 这轮比赛时长
  duration_str: string

  // 我的家族接口
  // 为false表示没有加入家族true表示加入家族
  in_family: boolean
  //   为0表示该日比赛已结束
  // 为1表示比赛进行中
  // 2:未开始
  myFamily_race_status: 0 | 1 | 2
  //  为0表示该家族已经被淘汰
  // 为1表示该家族晋级
  // 当比赛在进行中根据该字段展示promoted或eliminated
  family_status: 0 | 1
  family_bonus: number
  my_bonus: number
  // 我的家族的tab中当我有家族的时候
  myFamily_own: ListItemType
  my_family_info: ListItemType
  member_list: Array<ListItemType>
  // 道具列表接口
  propsList: Array<PropItemType>
  // 房间内h5的信息
  room_in_family: boolean
  room_price_pool: number
  room_msg: string
  // 为0表示该家族已经被淘汰  为1表示该家族晋级
  room_family_status: number
  // 排名
  ranking: number
  // 走了多远
  distance: number
  // 离前一名距离
  previous: number
  // 距离晋级的距离
  promotion: number
  // 收到钻石数目
  inroom_diamonds: number
  // 我在家族中的排名
  inroom_my_ranking: number
  // 房间中判断是常规赛还是巅峰赛
  inroom_is_regular: boolean
  // 房间比赛 倒计时
  count_down?: number
  // 广播消息
  offset: number
  waiting_tm: number
  // 房间内的时候的广播
  broadcastList: Array<string>
  // 轮次结果通知结果
  title: string
  // Desc: string
  res_family_info: ResFamilyItem
  // true: 普通分组赛 false: N进48
  is_six_team: boolean
  win_title: string
  win_list: Array<ListItemType>
  lose_title: string
  lose_list: Array<ListItemType>
  // 当前房间家族是否是我的家族
  room_family_ismine: boolean
  // 是否比赛进行中
  // true 是 false 不是
  room_race_status: boolean
  // live/activity/fmrc_show_rank接口轮询间隔秒数
  show_rank_freq: number
  // live/activity/fmrc_list_property接口轮询间隔
  list_property: number
  is_same_area: boolean
  webData?: any
}

const initialState: FamilySpeedSt = {
  // 静态拉取数据status 数据
  is_same_area: true,
  sid: 1,
  // 0:常规赛 1：巅峰赛
  race_type: 0,
  race_day_list: ['11.16', '11.17', '11.18', '11.19'],
  // 读数组的时候需要减一去读，真实的发送的时候也需要从1开始
  race_day: 1,
  race_status: 0,
  circle_list: [],
  // 读数组的时候需要减一去读，真实的发送的时候也需要从1开始
  circle_index: 1,
  group_list: [],
  group_index: 1,
  prize_rate: '',
  // 常规赛奖金比例
  prize_rate_regular: '',
  // 巅峰赛奖金比例
  prize_rate_peak: '',
  prize_pool: 0,
  // 赛程接口
  // 不同的天的奖池奖金数目 当日奖金数目
  schedule_prize_pool: 0,
  // 1: 返回的是获奖家族列表
  prize_status: 0,
  // 1：处于比赛休息中
  rest_status: 0,
  accounting_status: 0,
  // 赛程接口家族是否晋级 1 晋级
  schedule_family_status: 1,
  //   是否展示用户所在家族排名信息
  // 1：展示
  show_own: 0,
  own: {
    member_info: {
      avatar: '',
      id: 0,
      name: '',
      zy_id: '',
    },
    rank: '',
    score: 0,
    meter: 0,
  },
  raceSchedule_race_status: 0,
  family_race_list: [],
  // 这轮开始时间
  st_str: '',
  // 这轮结束时间
  et_str: '',
  // m进n的字符串
  m_to_n_str: '',
  // 比赛后剩多少个
  m_to_n: '',
  duration_str: '',

  // 我的家族接口
  // 为false表示没有加入家族true表示加入家族
  in_family: false,
  //   为0表示该日比赛已结束
  // 为1表示比赛进行中
  // 2:未开始
  myFamily_race_status: 0,
  //  为0表示该家族已经被淘汰
  // 为1表示该家族晋级
  // 当比赛在进行中根据该字段展示promoted或eliminated
  family_status: 0,
  family_bonus: 0,
  my_bonus: 0,
  // 我在我的家族的贡献榜中的排名和信息
  myFamily_own: {
    member_info: {
      avatar: '',
      id: 0,
      name: '',
      zy_id: '',
    },
    rank: '',
    score: 0,
  },
  // 我的家族的tab中当我有家族的时候
  my_family_info: {
    member_info: {
      avatar: '',
      id: 0,
      name: '',
      zy_id: '',
    },
    rank: '',
    score: 0,
  },
  member_list: [],

  // 房间内h5使用道具
  propsList: [],
  // 房间内h5的信息
  room_in_family: false,
  room_price_pool: 0,
  room_msg: '',
  // 为0表示该家族已经被淘汰  为1表示该家族晋级
  room_family_status: 1,
  // 当前房间家族是否是我的家族
  room_family_ismine: true,
  // 排名
  ranking: 0,
  // 走了多远
  distance: 0,
  // 离前一名距离
  previous: 0,
  // 距离晋级的距离
  promotion: 0,
  // 收到钻石数目
  inroom_diamonds: 0,
  // 我在家族中的排名
  inroom_my_ranking: 0,
  // 房间中判断是常规赛还是巅峰赛
  inroom_is_regular: true,
  // 房间比赛 倒计时
  // count_down: 0,
  // 广播消息
  // 初始偏移量为0
  offset: 0,
  // 默认等3s去拉取接口
  waiting_tm: 3,
  broadcastList: [],
  // 轮次结果通知结果
  title: '',
  // Desc: '',
  res_family_info: {
    // 为0表示该家族已经被淘汰 为1表示该家族晋级
    family_status: 0,
    name: '',
    rank: 0,
  },
  // 默认还是不是好，因为如果是的话就需要展示淘汰和晋级列表了
  is_six_team: false,
  win_title: '',
  win_list: [],
  lose_title: '',
  lose_list: [],
  // 是否比赛进行中
  // true 是 false 不是
  room_race_status: true,
  // live/activity/fmrc_show_rank接口轮询间隔秒数
  show_rank_freq: 3,
  // live/activity/fmrc_list_property接口轮询间隔
  list_property: 3,
}

// 基础信息 https://doc2.ixiaochuan.cn/pages/viewpage.action?pageId=21649402
export const getStatusData = createAsyncThunk(
  'activity/fmrc_status',
  async (
    arg: {
      room_id?: number
    },
    store
  ) => {
    // 待完善 http的返回类型
    const resp = await http.post('/live/activity/fmrc_status', {
      ...arg,
      ...store.getState().env.deviceinfo,
    })
    return resp.data
  }
)
// 获取赛程接口 https://doc2.ixiaochuan.cn/pages/viewpage.action?pageId=21649168
export const getScheduleList = createAsyncThunk(
  'activity/fmrc_list',
  async (
    arg: {
      room_id?: number
      race_day: number
      circle_index: number
      group_index: number
    },
    store
  ) => {
    const {sid} = store.getState().FamilySpeed
    // 待完善 http的返回类型
    const resp = await http.post('/live/activity/fmrc_list', {
      sid,
      ...arg,
      ...store.getState().env.deviceinfo,
    })
    return resp.data
  }
)
// my family tab的接口
export const getMyFamily = createAsyncThunk(
  '/live/activity/fmrc_member_list',
  async (arg: {race_day: number}, store) => {
    const {sid} = store.getState().FamilySpeed
    // 待完善 http的返回类型
    const resp = await http.post('/live/activity/fmrc_member_list', {
      sid,
      ...arg,
      ...store.getState().env.deviceinfo,
    })
    return resp.data
  }
)
// /live/activity/fmrc_list_status 比赛历史榜单的分组信息 https://doc2.ixiaochuan.cn/pages/viewpage.action?pageId=21656309
export const fmrc_list_status = createAsyncThunk(
  '/live/activity/fmrc_list_status',
  async (
    arg: {room_id?: number; race_day: number; circle_index: number},
    store
  ) => {
    const {sid} = store.getState().FamilySpeed
    // 待完善 http的返回类型
    const resp = await http.post('/live/activity/fmrc_list_status', {
      sid,
      ...arg,
      ...store.getState().env.deviceinfo,
    })
    return resp.data
  }
)
// 初始化接口  https://doc2.ixiaochuan.cn/pages/viewpage.action?pageId=25160085
export const fmrc_property_init = createAsyncThunk(
  'fmrc_property_init',
  async (arg: {room_id: number}, store) => {
    // 待完善 http的返回类型
    const resp = await http.post('live/activity/fmrc_property_init', {
      ...arg,
      ...store.getState().env.deviceinfo,
    })
    return resp.data
  }
)
// 判断房间中的家族是否同一个区 https://doc2.ixiaochuan.cn/pages/viewpage.action?pageId=25160863

export const fmrc_is_same_area = createAsyncThunk(
  'fmrc_is_same_area',
  async (arg: {room_id: number}, store) => {
    // 待完善 http的返回类型
    const resp = await http.post('/live/activity/fmrc_is_same_area', {
      ...arg,
      ...store.getState().env.deviceinfo,
    })
    return resp.data
  }
)
// 房间内获取道具列表 https://doc2.ixiaochuan.cn/pages/viewpage.action?pageId=21649160
export const getPropsList = createAsyncThunk(
  'activity/fmrc_list_property',
  async (arg: {room_id: number}, store) => {
    const {h_m} = store.getState().env.deviceinfo
    // 待完善 http的返回类型
    const resp = await http.post('/live/activity/fmrc_list_property', {
      mid: h_m,
      ...arg,
      ...store.getState().env.deviceinfo,
    })
    return resp.data
  }
)
// setTimOut 轮询 获取家族排名 https://doc2.ixiaochuan.cn/pages/viewpage.action?pageId=21650115
export const getRankInRoom = createAsyncThunk(
  'live/activity/fmrc_show_rank',
  async (arg: {room_id: number}, store) => {
    // 待完善 http的返回类型
    const resp = await http.post('/live/activity/fmrc_show_rank', {
      ...arg,
      ...store.getState().env.deviceinfo,
    })
    return resp.data
  }
)
// 使用道具接口 https://doc2.ixiaochuan.cn/pages/viewpage.action?pageId=21649223
export const useProp = createAsyncThunk(
  'live/activity/fmrc_use_property',
  async (arg: {room_id: number; pid: number; num: number}, store) => {
    // 待完善 http的返回类型
    const {h_m} = store.getState().env.deviceinfo

    const resp = await http.post(
      '/live/activity/fmrc_use_property',
      {
        mid: h_m,
        ...store.getState().env.deviceinfo,
        ...arg,
      },
      {
        xcErrorToast: true,
      }
    )
    return resp.data
  }
)
// setInterval 获取消息轮询接口 https://doc2.ixiaochuan.cn/pages/viewpage.action?pageId=21649759
export const getBroadcastMsgs = createAsyncThunk(
  '/live/activity/fmrc_property_history',
  async (arg: {room_id: number}, store) => {
    // 待完善 http的返回类型
    const {offset} = store.getState().FamilySpeed

    const resp = await http.post('/live/activity/fmrc_property_history', {
      offset,
      ...store.getState().env.deviceinfo,
      ...arg,
    })
    return resp.data
  }
)

// 获取轮次结果接口 https://doc2.ixiaochuan.cn/pages/viewpage.action?pageId=21649761
export const getRoundResult = createAsyncThunk(
  '/live/activity/fmrc_result_notify',
  async (arg: {room_id: number}, store) => {
    // 待完善 http的返回类型
    const {h_m} = store.getState().env.deviceinfo
    const resp = await http.post('/live/activity/fmrc_result_notify', {
      mid: h_m,
      ...store.getState().env.deviceinfo,
      ...arg,
    })
    return resp.data
  }
)
// 获取房间请求rank的评率
export const fmrc_inroom_config = createAsyncThunk(
  '/live/activity/fmrc_inroom_config',
  async (arg: any, store) => {
    const resp = await http.post(
      '/live/activity/fmrc_inroom_config',
      store.getState().env.deviceinfo
    )
    return resp.data
  }
)

export const FamilySpeedSlice = createSlice({
  name: 'FamilySpeed',
  initialState,
  reducers: {
    get_gift: (state, action) => {
      const {webData} = action.payload
      Object.assign(state, {webData})
    },
  },
  extraReducers: (builder) => {
    // 拉取基础数据
    builder.addCase(getStatusData.fulfilled, (state, action) => {
      const {data = {}} = action.payload
      Object.assign(state, data)
    })
    // 切换历史赛程的时候提前确认group
    builder.addCase(fmrc_list_status.fulfilled, (state, action) => {
      const {data = {}} = action.payload
      Object.assign(state, data)
    })
    // 赛程的接口
    builder.addCase(getScheduleList.fulfilled, (state, action) => {
      const {data = {}} = action.payload
      const {race_status, family_race_list, own, show_own, ...rest} = data
      // getScheduleList接口的字段只修改了race_status
      const ret: any = {
        // 因为race_status接口字段有重复
        // 以及特殊字段处理
        raceSchedule_race_status: race_status,
        family_race_list: family_race_list || [],
        show_own,
      }
      if (own) {
        ret.own = own
      } else {
        // 此处进行一个双重判断，防止show_own返回的是true但是没有给own
        ret.show_own = false
      }
      // Object.assign(state, ret)
      Object.assign(state, ret, rest)
    })

    // myFamily的接口
    builder.addCase(getMyFamily.fulfilled, (state, action) => {
      const {data = {}} = action.payload
      const ret: any = {
        in_family: data.in_family,
        myFamily_race_status: data.race_status,
        family_status: data.family_status,
        family_bonus: data.family_bonus,
        my_bonus: data.my_bonus,
        member_list: data.member_list || [],
      }
      if (data.own) {
        // 我在家族中的排名
        ret.myFamily_own = data.own
      }

      if (data.my_family_info) {
        // 我的家族的信息
        ret.my_family_info = data.my_family_info
      } else {
        // 此处进行一个双重判断，防止in_family返回的是true但是没有给my_family_info
        ret.in_family = false
      }
      Object.assign(state, ret)
    })
    builder.addCase(getPropsList.fulfilled, (state, action) => {
      const {data = {}} = action.payload
      const ret: any = {
        propsList: data.list || [],
      }
      Object.assign(state, ret)
    })

    builder.addCase(fmrc_inroom_config.fulfilled, (state, action) => {
      const {data = {}} = action.payload

      const ret: any = {
        show_rank_freq: 3,
      }
      // 如果大于3 就去更新
      if (data.show_rank_freq > 3) {
        ret.show_rank_freq = data.show_rank_freq
      }
      // 如果大于3 就去更新
      if (data.list_property > 3) {
        ret.list_property = data.list_property
      }
      Object.assign(state, ret)
    })

    builder.addCase(fmrc_is_same_area.fulfilled, (state, action) => {
      const {data = {}} = action.payload
      Object.assign(state, data)
    })
    builder.addCase(fmrc_property_init.fulfilled, (state, action) => {
      const {data = {}} = action.payload
      const {
        in_family,
        prize_pool,
        message,
        family_status,
        history_list,
        property_list,
        ...rest
      } = data
      const ret: any = {
        room_in_family: in_family,
        room_price_pool: prize_pool,
        room_msg: message,
        room_family_status: family_status,
        broadcastList: history_list || [],
        propsList: property_list || [],
      }
      Object.assign(state, ret, rest)
    })
    builder.addCase(getRankInRoom.fulfilled, (state, action) => {
      const {data = {}} = action.payload
      const {in_family, prize_pool, message, family_status, ...rest} = data
      const ret: any = {
        room_in_family: in_family,
        room_price_pool: prize_pool,
        room_msg: message,
        room_family_status: family_status,
      }
      Object.assign(state, ret, rest)
    })
    builder.addCase(getRoundResult.fulfilled, (state, action) => {
      // 结果通知
      const {data = {}} = action.payload
      Object.assign(state, data)
    })
    builder.addCase(getBroadcastMsgs.fulfilled, (state, action) => {
      // 获得轮询的msg
      const {data = {}} = action.payload
      // Object.assign(state, data)
      const ret: any = {
        // broadcastList: data.list || [],
        waiting_tm: data.waiting_tm,
        offset: data.offset,
      }
      if (data.list.length > 0) {
        // 只有当返回的list长度大于0的时候才去重置msg
        ret.broadcastList = data.list
      }
      Object.assign(state, ret)
    })
  },
})
export const WildBlindBoxActions = FamilySpeedSlice.actions
export default FamilySpeedSlice.reducer
